import { screen } from '@/router/screenRoutes';

export default [
  // routes
  {
    ...screen('credit-card-proposals'),
    component: () => import('@/views/creditCard/List.vue'),
  },
  {
    ...screen('credit-card-simulator'),
    component: () => import('@/views/creditCard/Simulator.vue'),
  },
  {
    ...screen('credit-card-proposal'),
    component: () => import('@/views/creditCard/Proposal.vue'),
  },

  // ── Redirects (legacy) ──
  {
    path: '/cartao/proposta/:proposal_id?',
    redirect: { name: 'credit-card-proposal' },
  },
];
